<!-- 直播间管理-->
<template>
  <div class="room-wrap">
    <a-spin size="large" class="spin" v-if="loading"/>
    <div class="search">
      <a-input @change="changeHandle" placeholder="标题名，主播昵称" style="width:480px;margin-right:20px;" v-model="searchName"/>
      <a-button type="primary" @click="getList()">查询</a-button>
      <a-button class="reset" @click="handleReset">重置</a-button>
    </div>

    <div v-if="roomList.length">
      <div class="room-list">
        <div class="room-box" v-for="item in roomList" :key="item.roomId">
          <img :src="item.avatar_image" alt="" class="bg-img" @click="goToRoom(item)">
          <div class="room-desc">{{item.title}}</div>
          <div class="info">
            <div class="info-name">{{item.nick_name}}</div>
            <div>
              <a-icon type="user" />
              {{item.view_num}}
            </div>
          </div>
          <!-- <a-button type="primary" style="margin-left:10px;margin-top:10px;">推广</a-button> -->
        </div>
      </div>
      <a-pagination
        v-model="current"
        :page-size-options="pageSizeOptions"
        :total="total"
        show-size-changer
        :page-size="pageSize"
        show-quick-jumper
        :showTotal="total => `共 ${total} 条`"
        @showSizeChange="onShowSizeChange"
        @change="onChange"
      >
        <template slot="buildOptionText" slot-scope="props">
          <span v-if="props.value !== '50'">{{ props.value }}条/页</span>
          <span v-if="props.value === '50'">全部</span>
        </template>
      </a-pagination>
    </div>
    <div v-else class="empty-text">
      当前没有正在进行的直播
      <!-- <a-result title="当前没有正在进行的直播">
        <template #extra>
        </template>
      </a-result> -->
    </div>
  </div>
</template>

<script>
export default {
  name: 'broadcastRoom',
  data () {
    return {
      loading: false,
      searchName: '',
      indicator: <a-icon type="loading" style="font-size: 24px,font-weight:bold;" spin />,
      pageSizeOptions: ['10', '20', '30', '40', '50'],
      current: 1,
      pageSize: 10,
      total: 50,
      params: {
        keywords: '',
        page: 1,
        pagesize: 10
      },
      roomList: [],
      searchList: [
        { props: ['keywords'], placeholder: '标题名，主播昵称', options: [], inputType: 'input' }
      ]
      // searchParams: {
      //   keywords: undefined
      // },
    };
  },
  created () {
    this.getList();
  },
  mounted () {},
  methods: {
    getList () {
      this.loading = true;
      this._get({
        url: '/live/rooms',
        params: {
          ...this.params
        }
      }).then(res => {
        // this.$message.success(res.msg)
        this.roomList = res.data.list;
        this.total = res.data.total;
        this.loading = false;
      }).catch(() => {
        this.$message.error('网络错误,请稍后重试');
        this.loading = false;
      });
    },
    goToRoom (item) {
      window.open(`${location.protocol}//${location.host}/#/${`broadcastRoomDetail?id=${item.roomId}&userId=${item.chat_account}`}`);
    },
    btnsHandler () {

    },
    /* 搜索查询 */
    changeHandle (e) {
      this.params.keywords = e.target.value;
    },
    /* 清空查询 */
    handleReset () {
      this.params = {
        keywords: '',
        page: 1,
        pagesize: 20
      };
      this.searchName = '';
      this.getList();
    },
    onChange (pageNumber) {
    },
    onShowSizeChange (current, pageSize) {
      this.pageSize = pageSize;
    },
    resHandle (res) {
      return res.records;
    }
  }
};
</script>

<style lang="scss" scoped>
.empty-text{
  font-size: 26px;
  font-weight: bold;
  text-align: center;
  margin-top: 80px;
}
.room-wrap{
  position: relative;
  display: flex;
  flex-direction: column;
  .spin{
    position: absolute;
    top: 50%;
    left: 50%;
  }
  .search{
    display: flex;
    margin-bottom: 20px;
    .reset{ margin-left: 8px;}
  }
  .room-list{
    width: 100%;
    display: flex;
    flex-wrap: wrap;
    margin-bottom: 30px;
    .room-box{
      width: 230px;
      height: 280px;
      border-radius: 8px;
      margin-right: 20px;
      margin-bottom: 20px;
      // box-shadow: 0 0 8px rgba(151, 151, 151, 0.2);
      position: relative;
      .bg-img{
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 200px;
        border-radius: 8px;
        cursor: pointer;
      }
      .room-desc{
        position: absolute;
        font-size: 16px;
        left: 0;
        bottom: 100px;
        width: 100%;
        padding: 0 20px;
        text-align: center;
        background-color: rgba(0,0,0,.3);
        color: #fff;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        z-index: 1;
      }
      .info{
        margin-top: 210px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 0 10px;
        .info-name{
          max-width: 150px;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
      }
    }
  }
}

</style>
